<template lang="html">
  <v-row justify="start">
    <!--50音順にする-->
    <v-col
      v-for="card in sortedCardList"
      :key="card.title"
      cols="12"
      sm="6"
      lg="4"
      align-self="stretch"
    >
      <v-card
        class="ma-3 pa-5 h-100 d-flex flex-column"
        variant="default"
        elevation="3"
      >
        <!--ヒーローイメージ-->
        <v-img :src="getImageHero(card.imageUrl1)"></v-img>
        <!--ロゴ画像-->
        <v-img :src="getImageUrl2(card.title)" class="my-5"></v-img>
        <!--会社名-->
        <v-card-title
          style="text-align: center; line-height: 2em;"
          class="card-text"
          >{{ card.gametitle }}</v-card-title
        >
        <v-divider></v-divider>
        <!--テキスト-->
        <v-card-text class="card-text my-3">
          <div v-html="card.text.replace(/<br>/g, '<br />')"></div>
        </v-card-text>
        <!--リンク-->
        <v-card-actions class="flex-column justify-center">
          <v-col v-if="card.linkUrl2">
            <v-btn
              variant="tonal"
              class="ma-auto text-capitalize"
              align="center"
              color="green-darken-3"
              :href="card.linkUrl2"
              target="_blank"
              rel="noopener noreferrer"
              block
              height="72"
            >
              <div class="card-text">{{ card.gametitle }}公式サイト</div>
            </v-btn>
          </v-col>
          <v-col v-if="card.linkUrl1"
            ><v-btn
              variant="tonal"
              class="ma-auto text-capitalize"
              color="green-darken-3"
              :href="card.linkUrl1"
              target="_blank"
              rel="noopener noreferrer"
              block
              height="72"
            >
              {{ card.title }}公式サイト
            </v-btn>
            <!-- v-ifの条件付きレンダリングでパラメータがあるときだけボタンを出している -->
          </v-col>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<style>
  .card-text {
    white-space: normal !important;
    overflow: auto;
    text-overflow: ellipsis;
  }
</style>

<script>
  import CompanyData from "./CompanyData";
  export default {
    data() {
      return {
        cardList: CompanyData.cardList,
        logoList: CompanyData.logoList,
      };
    },
    created() {
      // cardList の各要素に対して、logoList から title プロパティに基づいてマッピングする
      this.cardList.forEach((card) => {
        card.logo = this.logoList.find((logo) => logo.title === card.title);
      });
    },
    computed: {
      sortedCardList() {
        return [...this.cardList].sort((a, b) => {
          const logoA = this.logoList.find((logo) => logo.title === a.title);
          const logoB = this.logoList.find((logo) => logo.title === b.title);
          const sortA = logoA ? logoA.sort || "" : ""; // a.titleに対応するlogoが存在しない場合は空文字列を代入
          const sortB = logoB ? logoB.sort || "" : ""; // b.titleに対応するlogoが存在しない場合は空文字列を代入
          return sortA.localeCompare(sortB, "ja", {
            sensitivity: "base",
          });
        });
      },
    },
    methods: {
      getImageHero(imagePath) {
        // パスが正しくない場合は何らかのデフォルト画像を返すことでエラーを回避
        if (!imagePath) {
          return ""; // デフォルト画像のパスを返す
        }
        return require(`@/assets/${imagePath}`);
      },

      getImageUrl2(title) {
        const logo = this.logoList.find((logo) => logo.title === title);
        return logo ? require(`@/assets/${logo.imageUrl2}`) : ""; // titleに対応するimageUrl2がなければ空文字列を返す
      },
    },
  };
</script>
